export default "__VITE_ASSET__BIIU$8Q$__"